/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import ProductDetail from "src/components/product/ProductDetail";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import * as MatStyled from "@mui/material/styles";
import { styled as muiStyled } from "@mui/styles";
import MuiDialog from "@mui/material/Dialog";

import {
  ChangeStatus,
  // seller
  requestHoldProduct,
  requestUnHoldProduct,
  requestDeleteProduct,
  // admin
  approvePendingProduct,
  holdProduct,
  unHoldProduct,
  deleteProduct,
  clearRequestProduct,
  updateProductPublic,
  getDataProductDetail,
  getProductListAdmin,
} from "src/api/product";

import device from "src/styles/device";
import font from "src/styles/font";

import { Box, Stack } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Button from "src/components/core/Button";

import { UseUpload } from "src/context/UploadProductContext";
import { useDialog } from "src/context/DialogContext";
import ProductCardElement from "src/components/product/ProductCard";
import { IOSSwitch } from "src/components/core/Switch";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useAuth } from "src/hooks/useAuth";

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  padding: 40px;
  /* padding-bottom: 140px; */
  margin-left: auto;
  margin-right: auto;
  background-repeat: repeat;
  position: relative;
  height: 90%;
  overflow: scroll;
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;

const DivTitle = styled.div`
  width: 100%;
  color: #252525;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;

  span {
    font-size: 1rem;
    font-weight: 400;
    color: #e13b30;
  }
`;

const DivSubTitle = styled.div`
  margin-top: 16px;
  font-size: 1rem;
  font-weight: 400;
  color: #e13b30;
`;

const RowStyledSimilar = styled.div`
  width: 88%;
  margin: auto;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
`;

const WrapperProductCard = styled.div`
  width: 200px !important;
  padding-bottom: 1px;
  position: relative;
  margin: 1px 8px 42px 8px;
`;

const WrapperKeyWord = styled.div`
  width: 100%;
  display: block;
`;

const Keyword = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 24px;
  color: rgb(37, 37, 37);
  display: flex;
  -webkit-box-align: center;
  align-items: center;

  /* ::before {
    content: '';
    width: 4px;
    color: rgb(225, 59, 48);
    background: rgb(225, 59, 48);
    display: inline-block;
    height: 32px;
    margin-right: 15px;
    border-radius: 3px;
  } */
`;

export const ButtonSlideImage = styled.button`
  width: 30px;
  height: 30px;
  background: transparent;
  border-radius: 16px;
  border: none;
  position: absolute;
  top: 50%;
  left: ${({ left }) => left && "-35px"};
  right: ${({ right }) => right && "-35px"};
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`;

export const WrapperFeature = styled.div`
  width: 100%;
  height: auto;
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
`;

export const TextFeature = styled.div`
  min-width: 50px;
  height: inherit;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 24px;
  text-align: center;
  color: #e13b30;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.mobileL} {
    white-space: nowrap;
  }
`;

export const Feature = styled.div`
  min-height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d9d9d9;
  cursor: pointer;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  :last-child {
    border-right: none;
  }
`;

export const FeatureScroll = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;

  &::-webkit-scrollbar-track {
    background: transparent;
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media ${device.mobile} {
    justify-content: flex-start;
  }
`;

const WrapperRequestProduct = styled.div`
  width: 100%;
  margin-top: 24px;
`;

const FormControlLabel = styled(MuiFormControlLabel)`
  min-width: 350px;
  padding: 14px 16px;
  border-radius: 16px;
  border: ${({ isSelected }) =>
    isSelected ? "1px solid #E13B30" : "1px solid #D9D9D9"};
  gap: 8px;

  &.MuiFormControlLabel-root {
    margin: 0;
  }

  .MuiRadio-root {
    padding: 0;
  }
`;

const ButtonGroup = styled(Stack)`
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  max-width: ${({ open }) => (open ? "calc(100% - 220px)" : "100%")};
  height: 100px;
  background-color: var(--white-color);
  padding: 24px 40px;
  border-radius: 24px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  .MuiButton-root {
    padding: 12px 24px;
    font-size: ${font.size.sm};
  }

  @media ${device.laptop} {
    max-width: unset;
  }
`;

export const DiscountWrapper = styled.div`
  width: 40px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 15px;
`;

export const DiscountPercent = styled.span`
  position: absolute;
  font-size: 0.625rem;
  color: white;
`;

export const WrapperTag = styled.div`
  width: auto;
  position: absolute;
  gap: 5px;
  display: flex;
  flex-direction: column;
  right: 0;
  padding-top: 5px;
`;

export const WrapperXclusiveDeal = styled.div`
  display: flex;
  align-items: start;
`;

const drawerWidth = 260;

// const Main = MatStyled.styled("main", {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   position: "relative",
//   flexGrow: 1,
//   transition: theme.transitions.create("margin", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   marginTop: "75px",
//   width: "100%",
//   height: "calc(100vh - 75px)",
//   overflow: "hidden",
//   overflowY: "scroll",
//   scrollBehavior: "smooth",
//   background: "#fff",
//   marginLeft: `-${drawerWidth}px`,
//   ...(open && {
//     transition: theme.transitions.create("margin", {
//       easing: theme.transitions.easing.easeOut,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//     marginLeft: 0,
//     position: "relative",
//   }),
// }));

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 24,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
    border: 0,
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

function ApproveProduct({
  open,
  status,
  onClose,
  productId,
  dataSearch = {},
  setProductListData = () => {},
  setRowCount = () => {},
}) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const {
    // dataUpload,
    initialAlert,
    alertInfo,
    setAlertInfo,
    setIsLoading,
  } = UseUpload();

  const { openDialog, closeDialog } = useDialog();
  const [dataUpload, setDataUpload] = useState({});
  const [dataUploadChoice, setDataUploadChoice] = useState([]);
  const [isPublic, setIsPublic] = useState(dataUpload?.is_public);
  const [requestStatus, setRequsetStatus] = useState("");

  const [actionButton, setActionButton] = useState({
    primaryText: "แก้ไข",
    secondaryText: "ย้อนกลับ",
    actionPrimary: () => {
      window.open(`/product/upload/${productId}`, "_blank");
    },
    actionSecondary: () => onClose(),
    disibledPrimary: false,
  });

  const handleRequest = (e) => {
    if (e.target.value === requestStatus) {
      setRequsetStatus("");
    } else {
      setRequsetStatus(e.target.value);
    }
  };

  const handleOnHold = () => {
    if (productId === null) return;
    setIsLoading(true);
    const holdPromise =
      user.role_id === 1
        ? holdProduct(productId)
        : requestHoldProduct(productId);

    holdPromise
      .then((res) => {
        (async () => {
          setIsLoading(false);
          closeDialog();
          setAlertInfo({
            ...alertInfo,
            visible: true,
            textError:
              user.role_id === 1
                ? "พักการขายสินค้าสำเร็จ"
                : "ส่งคำขอพักการขายสินค้าสำเร็จ",
            typeError: "success",
          });
          setTimeout(() => {
            setAlertInfo(initialAlert);
            if (user.role_id === 1) navigate(`/product/list`);
            else window.location.reload();
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.message,
          typeError: "error",
        });
        closeDialog();
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  const handleOnUnHold = () => {
    if (productId === null) return;
    setIsLoading(true);
    const unHoldPromise =
      user.role_id === 1
        ? unHoldProduct(productId)
        : requestUnHoldProduct(productId);

    unHoldPromise
      .then((res) => {
        (async () => {
          setIsLoading(false);
          closeDialog();
          setAlertInfo({
            ...alertInfo,
            visible: true,
            textError:
              user.role_id === 1
                ? "ยกเลิกพักการขายสินค้าสำเร็จ"
                : "ส่งคำขอยกเลิกการพักการขายสินค้าสำเร็จ",
            typeError: "success",
          });
          setTimeout(() => {
            setAlertInfo(initialAlert);
            if (user.role_id === 1) navigate(`/product/list`);
            else window.location.reload();
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.message,
          typeError: "error",
        });
        closeDialog();
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  const handleOnDelete = () => {
    if (productId === null) return;
    setIsLoading(true);
    const deletePromise =
      user.role_id === 1
        ? deleteProduct(productId)
        : requestDeleteProduct(productId);

    deletePromise
      .then((res) => {
        (async () => {
          setIsLoading(false);
          closeDialog();
          setAlertInfo({
            ...alertInfo,
            visible: true,
            textError:
              user.role_id === 1 ? "ลบสินค้าสำเร็จ" : "ส่งคำขอลบสินค้าสำเร็จ",
            typeError: "success",
          });
          setTimeout(() => {
            setAlertInfo(initialAlert);
            navigate(`/product/list`);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.message,
          typeError: "error",
        });
        closeDialog();
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  const handleOnClearRequest = () => {
    if (productId === null) return;
    setIsLoading(true);
    const clearRequestPromise = clearRequestProduct(productId);

    clearRequestPromise
      .then((res) => {
        (async () => {
          setIsLoading(false);
          closeDialog();
          setAlertInfo({
            ...alertInfo,
            visible: true,
            textError: "ClearRequest Success",
            typeError: "success",
          });
          setTimeout(() => {
            setAlertInfo(initialAlert);
            navigate(`/product/list`);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.message,
          typeError: "error",
        });
        closeDialog();
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  const handleTogglePublic = async (id, is_public) => {
    try {
      await updateProductPublic(id, is_public);
      await fetchProductDetails(id);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProductDetails = async (id) => {
    try {
      setIsLoading(true);
      const { data: product } = await getDataProductDetail(id);
      setDataUpload(product?.product);
      setDataUploadChoice(product?.product_choices);
      setIsPublic(product?.product?.is_public);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApproveNewProduct = async () => {
    try {
      setIsLoading(true);
      await ChangeStatus(productId, "approve");
      onClose();
      const { data } = await getProductListAdmin(dataSearch);
      setProductListData(data.rows);
      setRowCount(data.count);
      setAlertInfo({
        ...alertInfo,
        visible: true,
        textError: "สำเร็จ",
        typeError: "success",
      });
      setTimeout(() => {
        setAlertInfo(initialAlert);
      }, 2500);
    } catch (err) {
      console.log("Error:", err);
      setAlertInfo({
        ...alertInfo,
        visible: true,
        textError: err.response?.data?.message || "An error occurred",
        typeError: "error",
      });
      setTimeout(() => {
        setAlertInfo(initialAlert);
      }, 2500);
    } finally {
      setIsLoading(false);
    }
  };

  const handleApprovePendingProduct = async () => {
    try {
      setIsLoading(true);
      await approvePendingProduct(productId);
      onClose();
      const { data } = await getProductListAdmin(dataSearch);
      setProductListData(data.rows);
      setRowCount(data.count);
      setAlertInfo({
        ...alertInfo,
        visible: true,
        textError: "สำเร็จ",
        typeError: "success",
      });
      setTimeout(() => {
        setAlertInfo(initialAlert);
      }, 2500);
    } catch (err) {
      console.log("Error:", err);
      setAlertInfo({
        ...alertInfo,
        visible: true,
        textError: err.response?.data?.message || "An error occurred",
        typeError: "error",
      });
      setTimeout(() => {
        setAlertInfo(initialAlert);
      }, 2500);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * @Seller action button
   */
  useEffect(() => {
    if (user.role_id === 3) {
      // ? check selected request status
      if (requestStatus === "hold") {
        // selected hold request
        setActionButton((prev) => ({
          ...prev,
          primaryText: "ส่งคำขอ",
          actionPrimary: () => {
            openDialog({
              type: "confirm",
              title: `คุณต้องการพักการขายสินค้าใช่หรือไม่?\nหากคุณกดยืนยันแล้วสินค้าจะยังคงแสดง\nหน้าเว็บ แต่ไม่สามารถกดเข้าตะกร้าได้`,
              onConfirm: () => {
                handleOnHold();
              },
              maxWidth: 342,
            });
          },
          disibledPrimary: false,
        }));
      } else if (requestStatus === "delete") {
        // selected delete request
        setActionButton((prev) => ({
          ...prev,
          primaryText: "ส่งคำขอ",
          actionPrimary: () => {
            openDialog({
              type: "confirm",
              title: `คุณต้องการลบสินค้าใช่หรือไม่?\nสินค้าของคุณจะถูกลบอย่างสมบูรณ์เมื่อได้\nรับการยืนยันจากแอดมิน`,
              onConfirm: () => {
                handleOnDelete();
              },
              maxWidth: 342,
            });
          },
          disibledPrimary: false,
        }));
      } else {
        // * other

        if (
          dataUpload?.status_request === "hold" ||
          dataUpload?.status_request === "unhold"
        ) {
          setActionButton((prev) => ({
            ...prev,
            primaryText: "ยกเลิกคำขอ",
            actionPrimary: () => {},
            disibledPrimary: true,
          }));
        } else if (dataUpload?.status === "hold") {
          setActionButton((prev) => ({
            ...prev,
            primaryText: "ยกเลิกคำขอ",
            actionPrimary: () => {
              openDialog({
                type: "confirm",
                title: `คุณต้องการขอยกเลิกพักการขายสินค้าของคุณใช่หรือไม่?`,
                onConfirm: () => {
                  handleOnUnHold();
                },
                maxWidth: 342,
              });
            },
            disibledPrimary: false,
          }));
        } else {
          setActionButton((prev) => ({
            ...prev,
            primaryText: "แก้ไข",
            secondaryText: "ย้อนกลับ",
            actionPrimary: () => {
              window.open(`/product/upload/${productId}`, "_blank");
            },
            actionSecondary: () => {
              onClose();
            },
            disibledPrimary: false,
          }));
        }
      }
    }
  }, [dataUpload, requestStatus]);

  /**
   * @Admin action button
   */
  useEffect(() => {
    if (user.role_id === 1) {
      if (dataUpload?.status === "new") {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "อนุมัติ",
          secondaryText: "แก้ไข",
          actionPrimary: async () => handleApproveNewProduct(),
          actionSecondary: async () => {
            window.open(`/product/upload/${productId}`, "_blank");
          },
        }));
      } else if (dataUpload?.status === "pending") {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "อนุมัติ",
          secondaryText: "แก้ไข",
          actionPrimary: async () => {
            handleApprovePendingProduct();
          },
          actionSecondary: () => {
            window.open(`/product/upload/${productId}`, "_blank");
          },
          disibledPrimary: false,
        }));
      } else if (dataUpload?.status_request === "hold") {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "อนุมัติ",
          secondaryText: "ไม่อนุมัติ",
          actionPrimary: () => handleOnHold(),
          actionSecondary: () => handleOnClearRequest(),
          disibledPrimary: false,
        }));
      } else if (dataUpload?.status_request === "unhold") {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "อนุมัติ",
          secondaryText: "ไม่อนุมัติ",
          actionPrimary: () => handleOnUnHold(),
          actionSecondary: () => handleOnClearRequest(),
          disibledPrimary: false,
        }));
      } else if (dataUpload?.status_request === "delete") {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "อนุมัติ",
          secondaryText: "ไม่อนุมัติ",
          actionPrimary: () => handleOnDelete(),
          actionSecondary: () => handleOnClearRequest(),
          disibledPrimary: false,
        }));
      } else {
        setActionButton((prev) => ({
          ...prev,
          primaryText: "แก้ไข",
          secondaryText: "ย้อนกลับ",
          actionPrimary: () => {
            window.open(`/product/upload/${productId}`, "_blank");
          },
          actionSecondary: () => {
            onClose();
          },
          disibledPrimary: false,
        }));
      }
    }
  }, [dataUpload]);

  useEffect(() => {
    try {
      fetchProductDetails(productId);
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      {dataUpload?._id && dataUploadChoice?.length > 0 ? (
        <Dialog
          onClose={onClose}
          aria-labelledby="customized-dialog-title"
          open={true}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: 1024,
                display: "flex",
                justifyContent: "space-between",
              },
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              borderRadius: "50%",
              border: "1px solid var(--lightgrey-color)",
              position: "absolute",
              right: 16,
              top: 16,
              color: "var(--primary-color)",
              zIndex: 1,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "var(--hover-color)",
                border: "1px solid white",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Container>
            <DivTitle>
              ตัวอย่างแสดงรายละเอียดสินค้าบนหน้าเว็บไซต์
              {dataUpload?.status_request === "hold" ? (
                <DivSubTitle>สินค้ามีการร้องขอพักการขาย</DivSubTitle>
              ) : dataUpload?.status_request === "unhold" ? (
                <DivSubTitle>สินค้ามีการร้องขอยกเลิกการพักการขาย</DivSubTitle>
              ) : dataUpload?.status_request === "delete" ? (
                <DivSubTitle>สินค้ามีการร้องขอการลบสินค้า</DivSubTitle>
              ) : null}
            </DivTitle>

            <ProductDetail
              dataUpload={dataUpload}
              dataUploadChoice={dataUploadChoice}
            />

            {dataUpload?.bundles?.length !== 0 && (
              <WrapperKeyWord>
                <Keyword>สินค้าที่ใช้คู่กัน</Keyword>
                <RowStyledSimilar>
                  {dataUpload?.bundles?.map((product, index) => (
                    <WrapperProductCard key={`similar-product-${index}`}>
                      <ProductCardElement
                        id={product?.bundle?._id}
                        unit={product?.unit_th}
                        size={`${product?.bundle?.size?.width}m. x ${product?.bundle?.size?.height}m. x ${product?.bundle?.size?.thickness}mm.`}
                        colorCode={product?.bundle?.color?._id}
                        // sellerLogo={product.similar.product.user.seller.profile_image}
                        // sellerName={product.similar.product.user.seller.company_name}
                        src={
                          !!product?.bundle?.group_image
                            ?.product_display_image &&
                          product?.bundle?.group_image?.product_display_image.replace(
                            ".com",
                            ".com/150x150",
                          )
                        }
                        itemcode={product?.bundle?.product?.item_code}
                        itemname={product?.bundle?.product?.item_name}
                        price={product?.bundle?.group_price}
                        productType={product?.bundle?.product?.product_types
                          .map((data) => data.type_th)
                          .join(",")}
                      />
                    </WrapperProductCard>
                  ))}
                </RowStyledSimilar>
              </WrapperKeyWord>
            )}

            {dataUpload?.similars?.length !== 0 && (
              <WrapperKeyWord>
                <Keyword>สินค้าที่คล้ายกัน</Keyword>
                <RowStyledSimilar>
                  {dataUpload?.similars?.map((product, index) => (
                    <WrapperProductCard key={`similar-product-${index}`}>
                      <ProductCardElement
                        id={product?.similar?._id}
                        unit={product?.unit_th}
                        size={`${product?.similar?.size?.width}m. x ${product?.similar?.size?.height}m. x ${product?.similar?.size?.thickness}mm.`}
                        colorCode={product?.similar?.color?._id}
                        // sellerLogo={product.similar.product.user.seller.profile_image}
                        // sellerName={product.similar.product.user.seller.company_name}
                        src={
                          !!product?.similar?.group_image
                            ?.product_display_image &&
                          product?.similar?.group_image?.product_display_image.replace(
                            ".com",
                            ".com/150x150",
                          )
                        }
                        itemcode={product?.similar?.product?.item_code}
                        itemname={product?.similar?.product?.item_name}
                        price={product?.similar?.group_price}
                        productType={product?.similar?.product?.product_types
                          .map((data) => data.type_th)
                          .join(",")}
                      />
                    </WrapperProductCard>
                  ))}
                </RowStyledSimilar>
              </WrapperKeyWord>
            )}

            {/* Seller request */}
            {user.role_id === 3 &&
            dataUpload.status !== "new" &&
            dataUpload.status !== "pending" &&
            dataUpload.status_request !== "hold" &&
            dataUpload.status_request !== "delete" ? (
              <WrapperRequestProduct>
                <FormControl>
                  <FormLabel
                    id="radio-request-group-label"
                    sx={{
                      mb: 3,
                      color: "var(--secondary-color)",
                      fontSize: font.size.md,
                      fontWeight: 600,
                      "&.Mui-focused": {
                        color: "var(--secondary-color)",
                      },
                    }}
                  >
                    คำร้องขอเกี่ยวกับสินค้า
                  </FormLabel>

                  <RadioGroup
                    aria-labelledby="radio-request-group-label"
                    value={requestStatus}
                    name="radio-request-group"
                    sx={{
                      gap: 2,
                    }}
                  >
                    <FormControlLabel
                      value="hold"
                      isSelected={requestStatus === "hold"}
                      disabled={
                        dataUpload.status_request === "hold" ||
                        dataUpload.status === "hold"
                      }
                      control={
                        <Radio
                          checked={
                            dataUpload.status_request === "hold" ||
                            dataUpload.status === "hold" ||
                            requestStatus === "hold"
                          }
                          sx={{
                            color: "var(--grey-color)",
                            "&.Mui-checked": {
                              color: "var(--primary-color)",
                            },
                            "&.Mui-disabled": {
                              color: "var(--grey-color)",
                            },
                          }}
                          onClick={handleRequest}
                        />
                      }
                      label="ขอพักการขายสินค้า"
                    />
                    <FormControlLabel
                      value="delete"
                      isSelected={requestStatus === "delete"}
                      control={
                        <Radio
                          sx={{
                            color: "var(--grey-color)",
                            "&.Mui-checked": {
                              color: "var(--primary-color)",
                            },
                          }}
                          onClick={handleRequest}
                        />
                      }
                      label="ขอลบสินค้า"
                    />
                  </RadioGroup>
                </FormControl>
              </WrapperRequestProduct>
            ) : null}
          </Container>

          <ButtonGroup
            open={open}
            flexDirection={"row"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            columnGap={2}
          >
            {/* isPublic toggle */}
            {user.role_id === 1 && (
              <>
                <FormControlLabel
                  sx={{
                    marginInline: 0,
                    border: 0,
                    minWidth: "unset",
                    margin: 0,
                  }}
                  control={
                    <IOSSwitch
                      checked={isPublic}
                      onChange={(e) => {
                        handleTogglePublic(productId, e.target.checked);
                      }}
                    />
                  }
                />
              </>
            )}

            <Button
              variant="outlined"
              size="large"
              onClick={actionButton.actionSecondary}
              sx={{
                width: "100%",
                maxWidth: 140,
                borderRadius: 4,
              }}
            >
              {actionButton.secondaryText}
            </Button>

            <Button
              variant="contained"
              size="large"
              disabled={actionButton.disibledPrimary}
              onClick={actionButton.actionPrimary}
              sx={{ width: "100%", maxWidth: 140, borderRadius: 4 }}
            >
              {actionButton.primaryText}
            </Button>
          </ButtonGroup>
        </Dialog>
      ) : null}
    </>
  );
}
export default ApproveProduct;
